import { useController, useFormContext, useFormState } from "react-hook-form";
import RadioCard from "src/components/RadioCard/RadioCard";
import FormStep from "src/features/vendorSponsorshipAdmin/components/FormStep/FormStep";
import { HelpCircle } from "lucide-react";
import { ColorPickerStep } from "src/features/vendorSponsorshipAdmin/components/ColorPickerStep";

const AppBrandingFormStepList = () => {
	const { control, setValue } = useFormContext<AppBrand>();

	const { field: textColor } = useController({
		control,
		name: "textColor"
	});

	const { field: brandName } = useController({
		control,
		name: "name",
		rules: { required: "Please fill out the required field" }
	});

	const { errors } = useFormState({ control });

	return (
		<ul className="flex flex-col gap-4">
			<li className="w-full">
				<FormStep
					stepNumber={1}
					title="App brand name"
					error={errors.name?.message}
				>
					<div>
						<input
							aria-label="brand name"
							className="w-full px-3 py-2 bg-white border border-border rounded-lg text-base text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-ring transition-colors"
							placeholder="App rebrand name"
							{...brandName}
						/>
					</div>
				</FormStep>
			</li>

			<li className="w-full">
				<FormStep
					stepNumber={2}
					title="Select brand colour"
					error={errors.brandColor?.message}
				>
					<ColorPickerStep
						name="brandColor"
						label="Pick a colour or enter a hex code"
					/>
				</FormStep>
			</li>

			<li className="w-full">
				<FormStep
					stepNumber={3}
					title="Text and menu colour"
					error={errors.textColor?.message}
				>
					<fieldset>
						<legend className="text-sm font-medium text-zinc-600 mb-3">
							Text and menu colour
						</legend>

						<div className="flex items-center gap-2">
							{["#000000", "#ffffff"].map((value) => {
								return (
									<RadioCard
										key={value}
										radioProps={{
											value,
											isChecked: textColor.value === value,
											onChange: (val) => setValue("textColor", val),
											name: "textColor"
										}}
										ariaLabel={value}
									>
										<div
											className="rounded h-10 w-[88px]"
											style={{ backgroundColor: value }}
										/>
									</RadioCard>
								);
							})}
						</div>
					</fieldset>
				</FormStep>
			</li>
		</ul>
	);
};

export default AppBrandingFormStepList;
